import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { IndicatorDataUpload } from './indicator-data-upload';

export type IIndicatorWorkflowConnectProps = ReactRedux.DispatchProp<Redux.Action>;

export const IndicatorDataUploadContainer: React.ComponentClass
  = ReactRedux.connect()(IndicatorDataUpload);
